import ColorHash from "color-hash"

export const createColorHash = () =>
  new ColorHash({ hue: { max: 360, min: 0 }, lightness: 0.5, saturation: 0.4 })
